import React, { useEffect, useState } from 'react';

import { getUserById, updateUser, updatePassword, requestUserDeletion } from '../../api'; 

import Particle from '../../componets/Particle';
import option2 from "../../assets/json/option2.json";
import { toast } from 'react-toastify';
import './ProfilePage.css';

function ProfilePage() {
    const [auth, setAuth] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [isChangingPassword, setIsChangingPassword] = useState(false);
    const [formData, setFormData] = useState({});
    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [passwordError, setPasswordError] = useState('');
    const [isRequestingDeletion, setIsRequestingDeletion] = useState(false);
    const [deletionReason, setDeletionReason] = useState('');
    const [isLoading, setIsLoading] = useState(false);



    useEffect(() => {
        getUserDetails(); 
    }, []);

    const getUserDetails = async () => {
        try {
            const localUser = JSON.parse(localStorage.getItem("user_info"));
            const result = await getUserById(localUser.result._id);
            setAuth(result.data);
            setFormData({
                ...result.data,
                dob: result.data.dob ? new Date(result.data.dob).toISOString().split('T')[0] : '',
            });
        } catch (error) {
            toast.error("Error fetching user details");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const handleEditClick = () => {
        setIsEditing(true);
        setIsChangingPassword(false);
    };

    const handleSaveClick = async () => {
        try {
            const localUser = JSON.parse(localStorage.getItem("user_info"));
            await updateUser(localUser.result._id, {
                ...formData,
                dob: new Date(formData.dob).toISOString().split('T')[0]
            });
            setAuth(formData);
            setIsEditing(false);
            toast.success("Profile updated successfully!");
        } catch (error) {
            toast.error("Error updating profile");
        }
    };

    const handleChangePasswordClick = () => {
        setIsChangingPassword(true);
        setIsEditing(false); 
    };

    const handleSavePasswordClick = async () => {
        setPasswordError('');
        const localUser = JSON.parse(localStorage.getItem("user_info"));
        const { currentPassword, newPassword, confirmPassword } = passwordData;

        if (newPassword !== confirmPassword) {
            setPasswordError('New passwords do not match.');
            toast.error("New passwords do not match.");
            return;
        }

        try {
            const result = await updatePassword(localUser.result._id, { currentPassword, newPassword });
            if (result.data.success) {
                toast.success("Password updated successfully.");
                setIsChangingPassword(false);
                setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
            } else {
                setPasswordError(result.data.message || 'Error updating password. Please check your current password and try again.');
                toast.error(result.data.message || "Error updating password. Please check your current password and try again.");
            }
        } catch (error) {
            setPasswordError('Error updating password. Please check your current password and try again.');
            toast.error("Error updating password. Please check your current password and try again.");
        }
    };

    const handleConfirmDeletionRequest = async () => {
        setIsLoading(true);
        try {
            const response = await requestUserDeletion({
                email: auth.email,
                name: auth.firstName,
                message: deletionReason
            });
            if (response.data && response.data.success) {
                toast.success("Your account deletion request has been submitted. It will be processed within 30 days.");
                setIsRequestingDeletion(false);
                setDeletionReason('');
            } else {
                toast.error(response.data.message || "Failed to submit request.");
            }
        } catch (error) {
            console.error("Deletion request error:", error);
            toast.error(
                error.response?.data?.message || 
                "Error submitting deletion request. Please try again."
            );
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="profile-page">
            <Particle option={option2} />
            <div className="profile-container">
                <h1 className="profile-heading">Profile Dashboard</h1>
                <div className="profile-details">
                    {!isChangingPassword && (
                        <>
                            <p className="highlight"><strong>Username:</strong> {isEditing ? (
                                <input 
                                    type="text" 
                                    name="firstName" 
                                    value={formData.firstName} 
                                    onChange={handleInputChange} 
                                />
                            ) : auth.firstName}</p>
                            <p className="highlight"><strong>Email:</strong> {isEditing ? (
                                <input 
                                    type="email" 
                                    name="email" 
                                    value={formData.email} 
                                    onChange={handleInputChange} 
                                />
                            ) : auth.email}</p>
                            {isEditing && (
                                <>
                                    <p><strong>Age:</strong> 
                                        <input 
                                            type="number" 
                                            name="age" 
                                            value={formData.age || ''} 
                                            onChange={handleInputChange} 
                                        />
                                    </p>
                                    <p><strong>Gender:</strong> 
                                        <input 
                                            type="text" 
                                            name="gender" 
                                            value={formData.gender || ''} 
                                            onChange={handleInputChange} 
                                        />
                                    </p>
                                    <p><strong>Date of Birth:</strong> 
                                        <input 
                                            type="date" 
                                            name="dob" 
                                            value={formData.dob || ''} 
                                            onChange={handleInputChange} 
                                        />
                                    </p>
                                    <p><strong>Field of Study:</strong> 
                                        <input 
                                            type="text" 
                                            name="fieldOfStudy" 
                                            value={formData.fieldOfStudy || ''} 
                                            onChange={handleInputChange} 
                                        />
                                    </p>
                                    <p><strong>City:</strong> 
                                        <input 
                                            type="text" 
                                            name="city" 
                                            value={formData.city || ''} 
                                            onChange={handleInputChange} 
                                        />
                                    </p>
                                    <p><strong>State:</strong> 
                                        <input 
                                            type="text" 
                                            name="state" 
                                            value={formData.state || ''} 
                                            onChange={handleInputChange} 
                                        />
                                    </p>
                                </>
                            )}
                        </>
                    )}
                </div>
                {isEditing && (
                    <button className="save-profile-button" onClick={handleSaveClick}>Save</button>
                )}
                {!isEditing && !isChangingPassword && (
                    <button className="edit-profile-button" onClick={handleEditClick}>Edit Profile</button>
                )}
                {isChangingPassword ? (
                    <div className="change-password-container">
                        <h2>Change Password</h2>
                        <input 
                            type="password" 
                            name="currentPassword" 
                            placeholder="Current Password" 
                            value={passwordData.currentPassword} 
                            onChange={handlePasswordChange} 
                        />
                        <input 
                            type="password" 
                            name="newPassword" 
                            placeholder="New Password" 
                            value={passwordData.newPassword} 
                            onChange={handlePasswordChange} 
                        />
                        <input 
                            type="password" 
                            name="confirmPassword" 
                            placeholder="Confirm New Password" 
                            value={passwordData.confirmPassword} 
                            onChange={handlePasswordChange} 
                        />
                        {passwordError && <p className="error-message">{passwordError}</p>}
                        <button className="save-password-button" onClick={handleSavePasswordClick}>Save Password</button>
                    </div>
                ) : ( 
                    <button className="change-password-button" onClick={handleChangePasswordClick}>Change Password</button>
                )}

                {isRequestingDeletion ? (
                    <div className="delete-request-container">
                        <h2>Request Account Deletion</h2>
                        <p className="delete-warning">
                            Are you sure you want to request deletion of your account and all associated practice data? 
                            This action cannot be undone once processed.
                        </p>
                        <textarea
                            placeholder="Optional: Why are you requesting deletion?"
                            value={deletionReason}
                            onChange={(e) => setDeletionReason(e.target.value)}
                            className="delete-reason-textarea"
                            maxLength={500}
                        />
                        <div className="delete-actions">
                            <button className="confirm-delete-button" onClick={handleConfirmDeletionRequest} disabled={isLoading}>
                                {isLoading ? "Submitting..." : "Submit Deletion Request"}
                            </button>
                            <button className="cancel-delete-button" onClick={() => setIsRequestingDeletion(false)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                ) : (
                    !isEditing && !isChangingPassword && (
                        <button className="delete-account-button" onClick={() => setIsRequestingDeletion(true)}>
                            Delete Account
                        </button>
                    )
                )}
            </div>

        </div>
    );
}

export default ProfilePage;
